import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/pages/home/home.component';
import { AboutComponent } from './components/pages/about/about.component';
import { ServiceComponent } from './components/pages/service/service.component';
import { ServiceThreeComponent } from './components/pages/service-three/service-three.component';
import { ProductDetailsComponent } from './components/pages/product-details/product-details.component';
import { BlogComponent } from './components/pages/blog/blog.component';
import { BlogRightSidebarComponent } from './components/pages/blog-right-sidebar/blog-right-sidebar.component';
import { BlogDetailsComponent } from './components/pages/blog-details/blog-details.component';
import { PricingComponent } from './components/pages/pricing/pricing.component';
import { RecentProjectComponent } from './components/pages/recent-project/recent-project.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { TeamComponent } from './components/pages/team/team.component';
import { TeamTwoComponent } from './components/pages/team-two/team-two.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { ProductsComponent } from './components/pages/products/products.component';
import { NewsComponent } from './components/pages/news/news.component';

const routes: Routes = [
    {path: '', component: HomeComponent},
    // {path: 'home-two', component: HomeTwoComponent},
    // {path: 'home-three', component: HomeThreeComponent},
    {path: 'about', component: AboutComponent},
    {path: 'products', component: ProductsComponent},
    {path: 'products/:categorie', component: ProductDetailsComponent},
    {path: 'news', component: NewsComponent},
    {path: 'service-one', component: ServiceComponent},
    {path: 'service-three', component: ServiceThreeComponent},
    {path: 'blog', component: BlogComponent},
    {path: 'blog-right-sidebar', component: BlogRightSidebarComponent},
    {path: 'blog-details', component: BlogDetailsComponent},
    {path: 'pricing', component: PricingComponent},
    {path: 'recent-project', component: RecentProjectComponent},
    {path: 'error', component: ErrorComponent},
    {path: 'team', component: TeamComponent},
    {path: 'team-two', component: TeamTwoComponent},
    {path: 'contact', component: ContactComponent},
    // Here add new pages component
    {path: '**', component: ErrorComponent} // This line will remain down from the whole pages component list
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy',useHash:true })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
